import { Injectable, inject } from '@angular/core';
import { DateTime } from 'luxon';
import { FeatureDashboardDataService } from './feature-dashboard.dataservice.service';

@Injectable({ providedIn: 'root' })
export class FeatureDashboardService {
  private featureDashboardDataService = inject(FeatureDashboardDataService);

  async inicializar(): Promise<void> {
    await this.featureDashboardDataService.carregarDashboard();
  }

  formatarNumero(valor: number): string {
    // CRÍTICO: Auto-detecta região da máquina do usuário para sistema internacional
    return valor.toLocaleString(); // Brasil: "1.247" | EUA: "1,247" | Alemanha: "1.247"
  }

  formatarData(dataISO: string): string {
    // CRÍTICO: Auto-detecta região da máquina do usuário para sistema internacional
    return DateTime.fromISO(dataISO)
      .toLocal()
      .toLocaleString(DateTime.DATE_SHORT);
  }
}
